import type { Category } from '@ilteducation/content-ref-data-types';
import { useTheme } from 'vuetify';
const themeToSubjectSlugMap = {
  biology: ['biologi', 'biologia'],
  civics: ['samhallskunskap', 'samfunnsfag', 'yhteiskuntaoppi'],
  english: ['engelska', 'engelsk', 'englanti'],
  physics: ['fysik', 'fysikk', 'fysiikka'],
  history: ['historia', 'historie'],
  chemistry: ['kemi', 'kjemi', 'kemia'],
  geography: ['geografi', 'maantieto'],
  physicalEducation: ['idrott-och-halsa', 'liikuntaa-ja-terveystieto'],
  mathematics: ['matematik', 'matematikk', 'matematiikka'],
  school: ['greppa-skolan'],
  homeAndConsumerStudies: ['hem-och-konsumentkunskap'],
  childrenAndRecreation: ['barn-och-fritid'],
  marketLanguage: ['svenskasva', 'suomen-kieli'],
  technology: ['teknik'],
  healthAndSocialCare: ['vard-och-omsorg'],
  crafts: ['slojd'],
  vehiclesAndTransport: ['fordon-och-transport'],
  religion: ['religion', 'uskonto', 'krle'],
  nativeLanguage: ['modersmal'],
};

export const getThemeName = (subject: Category['slug']) => {
  const theme = useTheme();
  let themeName = 'light';
  if (!subject) return themeName;
  Object.entries(themeToSubjectSlugMap).forEach(([t, slugs]) => {
    if (slugs.includes(subject)) {
      themeName = t;
    }
  });
  if (theme.current.value.dark) {
    themeName = `${themeName}Dark`;
  }
  return themeName;
};
